import { InjectionToken } from '@angular/core';

export const ADMIN_API_SERVER_URL = new InjectionToken<string>('Admin web api server url');


